import nextAction from 'model/actions/utilities/nextAction';

const end = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'One of the brothers climbs the rope, kicks out the bars and rappels down. The other right behind him. ',
    "They stop in their tracks as they see my face. They don't even notice the gun.",
    'A murderous rage builds inside me. ',
    'one of them starts to speak "You..."',
    'I shoot them both dead before another sound is uttered',
    'The commotion causes plenty of noise and a deputy comes to investigate. Time to make myself scarce'
  ],
  buttons: [nextAction('Run off', onDone)]
});

const breakout = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'I decide to find out for myself.',
    'I secure a rope to the tree and throw it through the window and into the jailhouse.',
    'Then I wait for them with my pistol drawn.',
    'If they recognize me, it means their story is a lie. They must have known me from before the caravan massacre.'
  ],
  buttons: [nextAction('Watch', onDone(end(onDone)))]
});

const arrest = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'they finally caught up to them in this town. ',
    'they were trying to befriend the fiends and earn their confidence so they could shoot or arrest them and claim the bounty on their heads.',
    'they gained their confidence and were supposed to leave together. but looks like the outlaws got suspicious and left town early.',
    "the townspeople then mistakenly assumed they were part of the gang. And now they'll hang.",
    'their story sounds unlikely'
  ],
  buttons: [nextAction("They're lying", () => onDone(breakout(onDone)))]
});

const story = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'they were riding through the woods near their home. heard screams and gunshots so they went to investigate',
    'as they got near, they saw a caravan in flames. bodies everywhere. women... children... everyone dead. ',
    'a pack of bandits quickly riding off',
    'they spent the next hours trying to rend aid and comforting the dying. then decided to chase the bandits.'
  ],
  buttons: [nextAction('Then what?', () => onDone(arrest(onDone)))]
});

const jail = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'at night I skulk by the jail. the window is high. too high to climb. but the bars are old and rusted.',
    "with a hushed voice, I try to get some answers. are these really bloodthrirsty bandits? what's their involvement with the caravan?",
    'they tell me their story'
  ],
  buttons: [nextAction('Listen', () => onDone(story(onDone)))]
});

const start = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'a big commotion in town. two brothers woken from their drunken stupor with ropes around their necks.',
    'part of a big gang that recently massacred a caravan - My caravan?',
    'sherif stopped the lynching and calmed the mood. brought them to jail to await trial.'
  ],
  buttons: [nextAction('Approach jail', () => onDone(jail(onDone)))]
});

export default start;
